import type { IFlag } from '@/components/claims/information/CPEFlags';
import { useMemo } from 'react';

interface UseIsFlagConditionResult {
  conditionMet: boolean;
  foundFlag: IFlag | null;
  ruleFlag?: string;
}

const useIsFlagCondition = (
  flagsList: IFlag[] | undefined,
  displayNameToCheck: string,
): UseIsFlagConditionResult => {
  const nameMappings: Record<string, string[]> = {
    'Licencia de Conducir de Asegurado': [
      'DRIVERS_LICENSE_IMAGE_UPLOAD_FORCED',
      'ADDITIONAL_DRIVERS_LICENSE_IMAGE_UPLOAD_FORCED',
      'IS_NOT_LICENSE_ACTIVE',
      'DOES_NOT_HAVE_VALID_LICENSE',
    ],
    'Licencia de Vehículo de Asegurado': [
      'DOES_NOT_HAVE_VALID_REGISTRATION',
      'HAS_PRVSNL_REGISTRATION',
      'CAR_REGISTRATION_IMAGE_UPLOAD_FORCED',
    ],
    Odómetro: ['DOES_NOT_HAVE_VEHICLE_ODOMETER_IMAGE'],
    Marbete: ['DOES_NOT_HAVE_VALID_MARBETE', 'MARBETE_IMAGE_UPLOAD_FORCED'],
    'Chasis (VIN Number)': [
      'VIN_IMAGE_UPLOAD_FORCED',
      'DOES_NOT_HAVE_VALID_VIN',
    ],
    'Tablilla de Asegurado': [
      'LICENSE_PLATE_IMAGE_UPLOAD_FORCED',
      'DOES_NOT_HAVE_VALID_LICENSE_PLATE',
    ],
    'Vehículo (Laterales, Frontal y Trasera) de Asegurado': [
      'DOES_NOT_HAVE_ALL_VEHICLE_IMAGES',
      'VEHICLE_IMAGE_UPLOAD_FORCED',
    ],
    'Daños de Asegurado': ['TOTAL_LOSS', 'DOES_NOT_HAVE_VEHICLE_DAMAGE_IMAGES'],
    'Interior del vehículo': [''],
    'Documentos adicionales': [''],
    'Video 360°': [''],
  };

  return useMemo(() => {
    if (!flagsList || flagsList.length === 0) {
      return { conditionMet: false, foundFlag: null, ruleFlag: '' };
    }

    const possibleNames = nameMappings[displayNameToCheck];
    if (!possibleNames || possibleNames.length === 0) {
      return { conditionMet: false, foundFlag: null, ruleFlag: '' };
    }

    const foundFlag = flagsList.find(
      (flag) => flag.status === 'created' && possibleNames.includes(flag.name),
    );

    return {
      conditionMet: !!foundFlag,
      foundFlag: foundFlag || null,
      ruleFlag: foundFlag?.name,
    };
  }, [flagsList, displayNameToCheck]);
};

export default useIsFlagCondition;
